import { AuditResourceType } from '@govinity/shared-config';
import { z } from 'zod';
import { paginationSchema, positiveIntSchema } from '../shared/index.js';
/** Action types for audit log entries */
export var AuditAction;
(function (AuditAction) {
    AuditAction["Create"] = "create";
    AuditAction["Update"] = "update";
    AuditAction["Delete"] = "delete";
})(AuditAction || (AuditAction = {}));
/**
 * Schema for querying audit logs by resource with pagination support
 */
export const auditLogQuerySchema = paginationSchema.extend({
    /** The type of resource to fetch audit logs for (e.g., "legislative_item") */
    resourceType: z.enum(AuditResourceType),
    /** The ID of the resource to fetch audit logs for */
    resourceId: positiveIntSchema,
});
/**
 * Schema for querying aggregate audit logs for a resource type (no specific resource ID)
 */
export const auditLogAggregateQuerySchema = paginationSchema.extend({
    /** The type of resource to fetch audit logs for (e.g., "role") */
    resourceType: z.enum(AuditResourceType),
});
/**
 * Type guard to check if an AuditChangeResponse is a collection change.
 */
export function isAuditCollectionChange(change) {
    return 'type' in change && change.type === 'collection';
}
